// removed by extract-text-webpack-plugin
module.exports = {"intro":"src-components-Intro----Intro-module---intro---7DbWt","introInner":"src-components-Intro----Intro-module---introInner---RTiws","introScrollThingy":"src-components-Intro----Intro-module---introScrollThingy---1aQhZ","credit":"src-components-Intro----Intro-module---credit---3jl4L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Intro/Intro.module.scss
// module id = 268
// module chunks = 221374088121123